import React from 'react';
import { RemittanceIcon, InsuranceIcon, FinancingIcon, ReferralIcon, ReKYCIcon } from "../icons";

/**
 * OpportunityCard - Mobile card view for opportunity inventory
 * Displays opportunity information in a touch-friendly card format
 */
const OpportunityCard = ({ data, onClick, fromAll = false }) => {
  const getOpportunityStatus = (status) => {
    const styles = {
      'Raw Lead': "bg-[#FFEEDC] text-[#ED9812]",
      'Fresh Lead': "bg-[#FEFAD8] text-[#B1A106]",
      'Profile Completed': "bg-[#BEC2FF] text-[#262BC6]",
      'Activated': "bg-[#E7FFD6] text-[#116D26]",
      'Rejected': "bg-[#FFEDE9] text-[#DD3730]",
      'Informaton Gathered': "bg-[#E3F3FF] text-[#00658E]",
      'Onboarded': "bg-[#E7FFD6] text-[#116D26]",
      'Collecting Documents': "bg-[#E3F3FF] text-[#00658E]",
      'Compliance Reviewing': "bg-[#E3F3FF] text-[#00658E]",
      'KYC Approved': "bg-[#E7FFD6] text-[#116D26]",
      'To Be Re-KYC': "bg-[#FFEEDC] text-[#ED9812]",
      'KYC Rejected': "bg-[#FFEDE9] text-[#DD3730]",
      'Preparing Quotations': "bg-[#E3F3FF] text-[#00658E]",
      'Pending Selected': "bg-[#FFEEDC] text-[#ED9812]",
      'Pending Payment': "bg-[#FEFAD8] text-[#B1A106]",
      'Expired': "bg-[#EEEEEE] text-[#94A3B8]"
    };
    return styles[status] || "bg-gray-100 text-gray-600";
  };

  const getProductIcon = (funnel) => {
    if (funnel?.includes('Remittance')) return <img src={RemittanceIcon} alt="Remittance" className="w-6 h-6" />;
    if (funnel?.includes('Insurance')) return <img src={InsuranceIcon} alt="Insurance" className="w-6 h-6" />;
    if (funnel?.includes('Financing')) return <img src={FinancingIcon} alt="Financing" className="w-6 h-6" />;
    if (funnel?.includes('Referral')) return <img src={ReferralIcon} alt="Referral" className="w-6 h-6" />;
    if (funnel?.includes('Re-KYC')) return <img src={ReKYCIcon} alt="Re-KYC" className="w-6 h-6" />;
    return null;
  };

  return (
    <div 
      onClick={onClick}
      className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
    >
      {/* Header: ID, Product, Status */}
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">#{data.sub_id}</span>
          <div className="flex items-center">
            {getProductIcon(data.funnel)}
          </div>
        </div>
        {data.status_name && (
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getOpportunityStatus(data.status_name)}`}>
            {data.status_name}
          </span>
        )}
      </div>

      {/* Account Name */}
      <h3 className="font-bold text-base text-gray-900 mb-2">{data.name}</h3>

      {/* Opportunity Name */}
      {data.opp_name && (
        <div className="mb-3">
          <span className="text-sm text-gray-600">Opportunity: </span>
          <span className="text-sm font-medium text-gray-900">{data.opp_name}</span>
        </div>
      )}

      {/* Owner (if fromAll) */}
      {fromAll && data.farmer_username && (
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Owner:</span>
          <span className="font-medium text-gray-900">{data.farmer_username}</span>
        </div>
      )}
    </div>
  );
};

export default OpportunityCard;

